import React from 'react'
import CurrencyFormat from 'react-currency-format';

export const AsBux = ({ children }) => <CurrencyFormat value={children} displayType="text" prefix={'$'} decimalScale={2} fixedDecimalScale />;